import { useState, useEffect } from "react";
import { useChartBar } from "../../hooks";

export default function Module_HealthAnalysisManagement_Bar({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  callMainAPI = () => null,
}) {
  const { renderBar } = useChartBar({
    setting: moduleData,
    isExportRawList: true,
  });
  const [chartData, setChartData] = useState({ raw: [], format: [] });

  // useEffect(() => {
  //   if (!apiData) return;

  //   console.log(moduleData, apiData);

  //   let formatData = [
  //     {
  //       是否異常: "人因工程",
  //       order: 99,
  //       人因工程: 6,
  //     },
  //     {
  //       是否異常: "過負荷(心理)",
  //       order: 99,
  //       "過負荷(心理)": 9,
  //     },
  //     {
  //       是否異常: "母性保護",
  //       order: 99,
  //       母性保護: 1,
  //     },
  //     {
  //       是否異常: "健康異常三級",
  //       order: 99,
  //       健康異常三級: 20,
  //     },
  //     {
  //       是否異常: "健康異常四級",
  //       order: 99,
  //       健康異常四級: 13,
  //     },
  //     // {
  //     //   是否異常: "新進同仁",
  //     //   order: 99,
  //     //   新進同仁: 0,
  //     // },
  //     // {
  //     //   是否異常: "個人健康問題",
  //     //   order: 99,
  //     //   個人健康問題: 0,
  //     // },
  //   ];

  //   setChartData({
  //     raw: exportData,
  //     format: formatData,
  //     export: null,
  //   });
  // }, [apiData, exportData]);

  useEffect(() => {
    const data = [
      {
        type: "健康異常四級",
        aa: 35,
        bb: 27,
        cc: 2,
        dd: 0,
        ee: 83,
      },
      {
        type: "健康異常三級",
        aa: 86,
        bb: 25,
        cc: 2,
        dd: 4,
        ee: 83,
      },
      {
        type: "人因工程",
        aa: 21,
        bb: 17,
        cc: 0,
        dd: 1,
        ee: 86,
      },
      {
        type: "過負荷(心理)",
        aa: 29,
        bb: 22,
        cc: 2,
        dd: 3,
        ee: 93,
      },
      {
        type: "母性保護",
        aa: 1,
        bb: 1,
        cc: 0,
        dd: 0,
        ee: 100,
      },
    ];
    setChartData({
      raw: data,
      format: data,
      export: null,
    });
  }, []);

  return (
    <>
      <div className="w-full overflow-auto">
        {renderBar({
          moduleTitle,
          options: {
            moduleData: {
              ...moduleData,
              // columns: [{ key: "uv" }, { key: "sv" }, { key: "pv" }],
            },
            chartData,
            callMainAPI,
          },
        })}
      </div>
    </>
  );
}
